module.exports = __webpack_public_path__ + "img/Icon_schedule_calendar.427aa426.svg";